export const ADD_FLASH_CARD_TOPIC_REQUEST =
  "ADD_FLASH_CARD_TOPIC_REQUEST";
export const ADD_FLASH_CARD_TOPIC_RESPONSE =
  "ADD_FLASH_CARD_TOPIC_RESPONSE";
export const GET_ALL_FLASH_CARD_TOPICS_REQUEST =
  "GET_ALL_FLASH_CARD_TOPICS_REQUEST";
export const GET_ALL_FLASH_CARD_TOPICS_RESPONSE =
  "GET_ALL_FLASH_CARD_TOPICS_RESPONSE";

export const EDIT_FLASH_CARD_TOPIC_REQUEST =
  "EDIT_FLASH_CARD_TOPIC_REQUEST";
export const EDIT_FLASH_CARD_TOPIC_RESPONSE =
  "EDIT_FLASH_CARD_TOPIC_RESPONSE";

export const DELETE_FLASH_CARD_TOPIC_REQUEST =
  "DELETE_FLASH_CARD_TOPIC_REQUEST";
export const DELETE_FLASH_CARD_TOPIC_RESPONSE =
  "DELETE_FLASH_CARD_TOPIC_RESPONSE";

export const GET_SINGLE_FLASH_CARD_TOPIC_REQUEST =
  "GET_SINGLE_FLASH_CARD_TOPIC_REQUEST";
export const GET_SINGLE_FLASH_CARD_TOPIC_RESPONSE =
  "GET_SINGLE_FLASH_CARD_TOPIC_RESPONSE";

// sub-topics
export const GET_ALL_FLASH_CARD_SUB_TOPICS_REQUEST =
  "GET_ALL_FLASH_CARD_SUB_TOPICS_REQUEST";
export const GET_ALL_FLASH_CARD_SUB_TOPICS_RESPONSE =
  "GET_ALL_FLASH_CARD_SUB_TOPICS_RESPONSE";

export const GET_SINGLE_FLASH_CARD_SUB_TOPIC_REQUEST =
  "GET_SINGLE_FLASH_CARD_SUB_TOPIC_REQUEST";
export const GET_SINGLE_FLASH_CARD_SUB_TOPIC_RESPONSE =
  "GET_SINGLE_FLASH_CARD_SUB_TOPIC_RESPONSE";

export const ADD_FLASH_CARD_SUB_TOPIC_REQUEST =
  "ADD_FLASH_CARD_SUB_TOPIC_REQUEST";
export const ADD_FLASH_CARD_SUB_TOPIC_RESPONSE =
  "ADD_FLASH_CARD_SUB_TOPIC_RESPONSE";

export const EDIT_FLASH_CARD_SUB_TOPIC_REQUEST =
  "EDIT_FLASH_CARD_SUB_TOPIC_REQUEST";
export const EDIT_FLASH_CARD_SUB_TOPIC_RESPONSE =
  "EDIT_FLASH_CARD_SUB_TOPIC_RESPONSE";

export const DELETE_FLASH_CARD_SUB_TOPIC_REQUEST =
  "DELETE_FLASH_CARD_SUB_TOPIC_REQUEST";
export const DELETE_FLASH_CARD_SUB_TOPIC_RESPONSE =
  "DELETE_FLASH_CARD_SUB_TOPIC_RESPONSE";
